import React from 'react';
import styles from './PlanCard.module.css';

interface PlanCardProps {
  isTopup: boolean;
  isPopular?: boolean;
  isBestValue?: boolean;
  oAmount: any;
  newAmount: any;
  discount: any;
  validity: string;
  balance: string;
  linkTo: any;
  ctaText: string;
  onClick: any;
  packageName?:string;
}

const PlanCard: React.FC<PlanCardProps> = ({isTopup, isPopular, isBestValue, oAmount, newAmount, discount, validity, balance, packageName, linkTo, ctaText, onClick }) => {
  // console.log("discount discount",newAmount)
  return (
    <div className={styles.PlanCard}>
      {/* {(isPopular || isBestValue) && <div className={styles.Tag}>{isPopular ? "Most Popular" : isBestValue ? "Best Value" : ""}</div>} */}
      <div className={styles.PlanCardAmount}>
      <div className={styles.PlanCardInfoi}>
          <div className={styles.PackageName}>{packageName}</div>
        </div>
        
        <div style={{display:"flex",flexDirection:"row",width:"100%"}}>
      <span className={styles.Rupees}>&#8377;</span>{newAmount} + GST
      </div>
        {/* {(newAmount==0 || !newAmount) ?<></>:
          <>
            <span className={styles.PlanCardOp}><span className={styles.Rupees}>&#8377;{oAmount}</span></span>
            <span className={styles.PlanCardDiscount}>{discount}% discount</span>
          </>
        } */}
        
      </div>
      <div className={styles.PlanCardInfo}>
        <div className={styles.PlanCardInfoi}>
          <div className={styles.PlanCardLabel}>Validity</div>
          <div className={styles.PlanCardData}>{validity}</div>
        </div>
        <div className={styles.PlanCardInfoi}>
          <div className={styles.PlanCardLabel}>Balance</div>
          <div className={styles.PlanCardData}>{balance} Credits</div>
        </div>
      </div>
      <span className={`CtaFilled ${styles.planCta}`} onClick={onClick}>{ctaText}</span>
    </div>
  );
};

export default PlanCard;
